<template>
    <div>
        <!-- ======= Home Section ======= -->
        <section id="hero" class="d-flex flex-column justify-content-center align-items-center">
            <div class="hero-container" data-aos="fade-in">
                <h1>Juan Fermín</h1>
                <vue-typed-js :strings="['Full Stack Developer']">
                    <h1><span class="typing"></span></h1>
                </vue-typed-js>
                <p>{{ $t('lang.about.updated')}}</p>
            </div>
        </section><!-- End Hero -->


        <main id="main">

            <!-- ======= About Section ======= -->
            <section id="about" class="about">
                <div class="container">
                    <div class="section-title">
                        <h2>{{ $t('lang.nav.about')}}</h2>
                        <p>{{ $t('lang.about.description')}}</p>
                    </div>

                    <div class="row">
                        <div class="col-lg-4" data-aos="fade-right">
                            <img src="/img/profile_photo.jpg" class="img-fluid" alt="">
                        </div>
                        <div class="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
                            <h3>{{ $t('lang.about.title_about')}}</h3>
                            <p class="font-italic">
                                {{ $t('lang.about.description_title_about')}}
                            </p>
                            <div class="row">
                                <div class="col-lg-6">
                                    <ul>
                                        <li><i class="icofont-rounded-right"></i> <strong>{{ $t('lang.about.birthday')}}:</strong> 7 Jul 1971</li>
                                        <li><i class="icofont-rounded-right"></i> <strong>{{ $t('lang.about.city')}}:</strong> Alicante - {{ $t('lang.about.country')}}</li>
                                        <li><i class="icofont-rounded-right"></i> <strong>{{ $t('lang.about.languages')}}:</strong> {{ $t('lang.about.spanish')}} - {{ $t('lang.about.english')}}</li>
                                    </ul>
                                </div>
                                <div class="col-lg-6">
                                    <ul>
                                        <li><i class="icofont-rounded-right"></i> <strong>{{ $t('lang.about.degree')}}:</strong> {{ $t('lang.about.degree_title')}}</li>
                                        <li><i class="icofont-rounded-right"></i> <strong>{{ $t('lang.about.email')}}:</strong> info@juanfermin.com</li>
                                        <li><i class="icofont-rounded-right"></i> <strong>{{ $t('lang.about.freelance')}}:</strong> {{ $t('lang.about.available')}}</li>
                                    </ul>
                                </div>
                            </div>
                            <p>{{ $t('lang.about.objectives') }}</p>
                        </div>
                    </div>

                </div>
            </section><!-- End About Section -->


            <!-- ======= Skills Section ======= -->
            <section id="skills" class="skills section-bg">
                <div class="container">

                    <div class="section-title">
                        <h2>{{ $t('lang.skills.skills')}}</h2>
                        <p>{{ $t('lang.skills.description')}}</p>
                    </div>

                    <div class="row skills-content">
                        <div class="col-lg-4" data-aos="fade-up">
                            <ul>
                                <li>
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABzUlEQVRIS72VP1LCUBDGvw1aq6VOmMGCSCeeAGgdormBeANuoJ5APYEeIRLH1ngD6TAWMkNGW2qBrPMCwSd5iQkOpnz/fvvtfrshrPijFb+P/wf45p4LcG05ZfSkOy91+W5MwcoBA9OwCTheRgEDd0XHs1IVDI6Mc2KciUPMWiMLiCh4DM8TLood7zwXoHjfc9Mgg2alngvgm+UWQDeRAgHwm+UrEPaVIKJNMKrTPT7VndfbdAVyRKw1QkBGZ4mULiqOuUgl+cOqlMZjlFQKiIIWgBNZcaoC8dhkErwlFW0RIptiVPjc2rX7w1SA2PRNg2eH+gD3VZFroOsdx7N90xA5DxXojhfLiHJUSIAus9Ym4irAlzIoyrdcnzyAZ0C4Ztr6cl0iiALQ1R1v5qbvUBIUzOYR4VnveAfi+JtV2lyfrIddOiqM7CjXftMYgrARBbOYznRA2J3UpnHwpD+8ClXzzz8sV3lNqxHz1XQxPujCVVUBZWdI+6LYUVeLifnDtqoxkRegbOR5TRRzKBEw7QW2GFz/bbKKCUogt1Age9vuxSyd6Y/2bhpWwFwHkSjyEMyuRuSKPkiVlVSD3y7l2c+kIM+DmWz6lwcX734BZsDrGeYGiCYAAAAASUVORK5CYII="/>
                                    <span> HTML5</span>
                                </li>
                                <li>
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABxElEQVRIS72V0VHCQBRF7wv+ywxhxk+sQKwALEADFUgFsh2IFbjYgFgBWS3AWIHQAfw5Q5ihAMlzNiGQJSFEZiC/u/vO3nff3RCO/NGR6+P0gIpQkpiuDlHGxOO5dETybEqBLZQHRuMQAAhfvnSauYBIAbqHAJjQL6KgB8ajBugDBCzyYAyU1xciPPnS6e1r0RoACm582fbyALYYNsHWZ7inGCBxABgBlKkgNtQEpC+UYbIB2H35laFV8d5h5tdIQQFAVQzrzNa3UZl4CtDApAWebp8t1LqlRMH1TLZHuR7oRbur2ASkxy9eTwL8vpPqSGaSU4Bwksi4GRP15/LWtYVywXA0sDjgQS1AOAdhDAQCKNXB/Gyqivq9Dibx1Jet2rZp2QriNK+MNCYlrrAydAPIbmMugIHJvO9c6poXYlhbohQ+AyUsvR/Znhh+ZTwTUTQyvqpQA2bch2kGD8CWO3+5U8mtoarAaoAQJpcIbzPpdIq2aJPmzYkFwKtUk1ZS3pq01DOxU0Fy9PKeiYMBut+/KLUAbsYjuBNEUAB5Z1i6sS97g7ZdrCI+WkDQJHAr8oVcwPJ0DvYpPP0vc9+N/rt+dAV/E6jiGThh74cAAAAASUVORK5CYII="/>
                                    <span> CSS3</span>
                                </li>
                                <li>
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABd0lEQVRIS72VQU7CQBSG/9cqcSc3EE9g14aaegM2VHZyA3VraophdC0nkKWUjTcQKHGtJxBPYNm5YPrMQGhaQELTwiwnM//3/vfevCFsedGW9bFbQMVyiwUZugDXARRTugsAant+8yZ+L+Hgouw8MeEqpXDyOOHeG4jGfDMBsE0nAHCYCQAeef7D8X8AziY+u+35Igp80cESIH44Dq9ZbimU8hXAyWJQqQFTsYm8nAuxhqA7EK1ZU8if7ICyY4WEt7iQxjh/GYqebTprXW+UotoyYKzpuqGAoZRfmR2oVBxM5FRwuvb00S8QFKTs5VIDBdiXYaKYXb/Zr57eGqRrCpJo7fRFXlEDYrQ6Q3G96nHmAgDQ93xh2WdOAww3Xoc8AJ8sw3r3/fHDNp02gKiFc3toSqhq3tUJ/Jypi8CIBlckRDAANgAqrRot61KUedgR8N3xRQTe7bhWdlXbgVBh4CjNZFWRM6Ed/wvU/d1+mWki3vTs1h38AVIfxRlFiHcuAAAAAElFTkSuQmCC"/>
                                    <span> Bootstrap</span>
                                </li>
                                <li>
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABRklEQVRIS+1VQU7CUBScqYS4o10L5rOxcWWPoCcQT6CeQD2B9QTKDTgCnkBvIDsCGxvrvmVLbMd8FAMmBqqFuODv3s97b97Mm/xPrPhwxf2xXoB00FAZjFw//hp8jsEGYCrvRqKFRvu/EinXEegEpG4BjERcIlMEhy6BEMCBpfdrBrYw6dcP6fBBxLm3F3dsDFQi4M3Y+/IALJvtSo/jLAEQATB/tukcA/DG81/CpG+M42ShgNNSAWwzQmFerbS9ZpQmw52Ach4B1ErZwYxXUxFXdh+jYf1O4kUhAFJt5QxABK4fu59L7k4cJBpC1wTua37cSga7oY2LAKSqbjWtBNOJR4NGR8Cxcp14+69WkslJno3LcfZkl10EwNZGhDofbWgEnM3I0yXUA+lKaE2dVBRg4dPwPeFHgMKdlihY75+8xECFU94BqH++GdpKYM8AAAAASUVORK5CYII="/>
                                    <span> JavaScript</span>
                                </li>
                                <li>
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACPUlEQVRIS7VVQW7TUBB94wTVgQW5AekJCCdoegLaZdxFGymu2NWcgHICwg7hSvUmzjY3wJwAcwLSE+AN1FaIpxon3/1x3PY3on9j+Wtm3sy8N/MJT3zoieNjK4D2yWU7CQaJSXJbAdju+CT1j4L/AiDZpk27m170Iwlov5t0aMHete94WwG8cMfdP/5RrJzt0/E5LCtIv/RnBcBw0mPiT5nvvHk0wPPT8ECc/n51piWAGyap77TVf1HRs53fYNpXVd0HtMaB7Yaz1Hc6DwVrueEoB46b4H292jqgEkCIA+gy9Z3yTmVLwGe956t7qXIPoADgAA26wj90QHlHF4AGEAqJezpA0XM3TBjg1jzbrUpTkiKQx8BrAn4CiKrklwAtN4zFEA3aVYQuSQ0DEI4l09TvD0yI1W30CkQlrwAe6CWKLLHgX0snMxBdiRstYmCa+c6hnoXiZ3UXoUEDvUrdtjUMPQbFSmF6i0YMnBXGNRKsgICBmJimOfLYsqjNQJcYBwB/rCVZylqAfhTxgbhukFY2o6V61o+QzExedTaqc1Ao6aF+F7yIJNVpYnZXy9YBhpMeiL/d5kaBPU/fm25O8ZMZka/y2dimxe5h+qA1YAamgclaqFuEtev6VvtrfY5ACGDR92o7igVo8VtiHNrzrKtXfOd7sFKNEPqybrgYSAgol6CQvDPPetV23vvgLMnkc5DIrx4IwBUxRtcXjiSzcYxeNPXowMp7KgLllFjEkfE2feyOMbU3qsA0WJ3dDQiwFChC0RKWAAAAAElFTkSuQmCC"/>
                                    <span> jQuery</span>
                                </li>
                            </ul>
                        </div>

                        <div class="col-lg-4" data-aos="fade-up" data-aos-delay="100">
                            <ul>
                                <li>
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACMUlEQVRIS71UQXLTQBDsWUzlSH6AeUGcDxDJByJfKOcBFPYLMGeiGEdwJn4BpngAKS5yOFhyPhDnBdg/MMcUZofaldZaGdlWkgp78soz3TPTPUt44EMPjI//R+CGwQCEp6ojYoylwIQYb/QdNB15x227WzueCX0hUWPCgY5hzKKG30py0+NcBE1ifDN3ZrhEGAAJKTO348aJusMJT1tE9DmNnTGjRYRomUs4ig/98xyBurgXQQxOqwAmTOhlpDTlnd/7Ounm8RXA1YRYF3IGYE8TEMbRoe8YspwGzo+PNZLyKvuT3jJx05ASo6dBCV0DRkznDP60rF6I/fjFu0khge4i0eJ1GjAXvDiQVLkucpvgxZ6kyhjAbjr7L2b2awmcqLtLN5UpgCcmiYDpsuo0U3XDQNUq5hfvLKqx25vbxRTatB4G721ACX4uQF+N4ABmEvxKgC7tcY68Y6VF7qzdA3cYqC60gwDEyopGcCYcEdCxDDGLPF+LXprACQMnZz3mNgnS3mbJA8um2klxw49vRaAFz9t2LvHopfou8Of7UtgVW5buQAU6YbdKVPlpOaKvO0Cy4fo3L57FjZ4aZ+HZ+hbVh8GZDbjikP7I8zvrwNX3rQT/2DZDK7TlrUZkguvDDx17W5PRZG/TvTowye4wUOufvDfAdeT5tU3Alm5lwpTgmW032fJOI8q6ONVPcOSdNMuVVUJkG0jZVt032fJeHZStesXKd0krn7N1D8pDFUf+BWhN2RkyIIy6AAAAAElFTkSuQmCC"/>
                                    <span> Vue.js</span>
                                </li>
                                <li>
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACHklEQVRIS81VPXLTUBDeXRk6y+IEmBnaKOpBJj5BzHAAmxu4TxGnoM8NUA7A4JzAxkpqzHPLDOQEyFIX5F3mCdsjyU+WKTyDGo30dr9v99ufh3DkB4+MD/8HwcTxnCcrPheQgc4YAYPfFt12o3lUp8DeDGbNkx4S9UGkZwRCHAtz0EkWt1VEOwSh450hS18gA3UKjoLfsm+U0xJghIBjIbzxo/k0f1Yg0ODAPKmKRkTeZ/iIHyulIermSQoE947nMfPXCucHP1ZtfRba7k8AeG6yS4ledKO5Pv+bbNkotF2pILjyYzVaE+j3pcnOj1UB00SgO6NVcl6mRG2L4ZUFAI8E9w1mHeWOnR+rQt12CVruFATe5AkE4KYTq0HYdD/p/36i3s1sN0CAfiEQhC/+Up1VFjlL30CgdX0qqcVC37UNIb98xMaqwfzj3wlst6DvNvqWe5EH85fqw53tjgXgPPd/W6d9RS4WsNR2eRJDW9cTZNOL+HndY5mms+bJoNz7eiY6ySIIm6fzzeCJyNtOshjvr0Fu2EwgW2eRqZ8sugVyQ7Y7XaQXW4P5FwBEwtIjxLYgBKaeF72jBCIk1FE7KdGz8gI0Lru1TNdV02ogexCRYVke4yTnne9sdygAuujlgdqYLRFg9DpWOhjjU3vhrCUbGlbDVUp0XXcn1BJswpo4XttiznbRimiUX2hV0ddKtM/x0LODMzgUsGx3dII/VsH0Gc88OdUAAAAASUVORK5CYII="/>
                                    <span> Angular</span>
                                </li>
                                <li>
                                    <img src="img/skills/php.png"/>
                                    <span> PHP</span>
                                </li>
                                <li>
                                    <img src="img/skills/laravel.png"/>
                                    <span> Laravel</span>
                                </li>
                                <li>
                                    <img src="img/skills/ionic.png"/>
                                    <span> Ionic</span>
                                </li>
                            </ul>
                        </div>

                        <div class="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                            <ul>
                                <li>
                                    <img src="img/skills/mysql.png"/>
                                    <span> MySQL</span>
                                </li>
                                <li>
                                    <img src="img/skills/git.png"/>
                                    <span> Git</span>
                                </li>
                                <li>
                                    <img src="img/skills/java.png"/>
                                    <span> Java SE</span>
                                </li>
                                <li>
                                    <img src="img/skills/c.png"/>
                                    <span> C#</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section><!-- End Skills Section -->

            <!-- ======= Resume Section ======= -->
            <section id="resume" class="resume">
                <div class="container">
                    <div class="section-title">
                        <h2>{{ $t('lang.resume.resume')}}</h2>
                        <p>{{ $t('lang.resume.description')}}</p>
                    </div>

                    <div class="row">
                        <div class="col-lg-6" data-aos="fade-up">
                            <h3 class="resume-title">{{ $t('lang.resume.education')}}</h3>
                            <div class="resume-item">
                                <h4>{{ $t('lang.resume.present') }}</h4>
                                <h5>2018 - {{ $t('lang.resume.actualidad') }}</h5>
                                <p><em>{{ $t('lang.resume.platforms')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.resume.marketing') }}</li>
                                    <li>{{ $t('lang.resume.server-side')}}</li>
                                    <li>{{ $t('lang.resume.client-side')}}</li>
                                    <li>{{ $t('lang.resume.mobile')}}</li>
                                    <li>{{ $t('lang.resume.seo')}}</li>
                                </ul>
                            </div>
                            <div class="resume-item">
                                <h4>{{ $t('lang.resume.proweb') }}</h4>
                                <h5>2017 - 2018 (20 {{ $t('lang.resume.credits')}} ECTS)</h5>
                                <p><em>{{ $t('lang.resume.ua') }}</em></p>
                                <ul>
                                    <li>{{ $t('lang.resume.ua-desc-1')}}</li>
                                    <li>{{ $t('lang.resume.ua-desc-2')}}</li>
                                    <li>{{ $t('lang.resume.ua-desc-3')}}</li>
                                    <li>{{ $t('lang.resume.ua-desc-4')}}</li>
                                    <li>{{ $t('lang.resume.ua-desc-5')}}</li>
                                    <li>{{ $t('lang.resume.ua-desc-6')}}</li>
                                    <li>{{ $t('lang.resume.ua-desc-7')}}</li>
                                    <li>{{ $t('lang.resume.ua-desc-8')}}</li>
                                </ul>
                            </div>
                            <div class="resume-item">
                                <h4>{{ $t('lang.resume.dam') }}</h4>
                                <h5>2014 - 2016 (2000 {{ $t('lang.resume.hours')}})</h5>
                                <p><em>I.E.S. San Vicente (San Vicente del Raspeig - Alicante)</em></p>
                                <ul>
                                    <li>{{ $t('lang.resume.dam-1') }}</li>
                                    <li>{{ $t('lang.resume.dam-2') }}</li>
                                </ul>
                            </div>
                            <div class="resume-item">
                                <h4>{{ $t('lang.resume.daw') }}</h4>
                                <h5>2012 - 2014 (2000 {{ $t('lang.resume.hours')}})</h5>
                                <p><em>I.E.S. Mare Nostrum (Alicante)</em></p>
                                <ul>
                                    <li>{{ $t('lang.resume.daw-1') }}</li>
                                    <li>{{ $t('lang.resume.daw-2') }}</li>
                                </ul>
                            </div>
                            <div class="resume-item">
                                <h4>{{ $t('lang.resume.euarc') }}</h4>
                                <h5>2011 - 2012 (22 {{ $t('lang.resume.credits')}} ECTS)</h5>
                                <p><em>{{ $t('lang.resume.ua') }}</em></p>
                                <p>{{ $t('lang.resume.euarc-title')}}</p>
                                <ul>
                                    <li>{{ $t('lang.resume.euarc-1') }}</li>
                                    <li>{{ $t('lang.resume.euarc-2') }}</li>
                                    <li>{{ $t('lang.resume.euarc-3') }}</li>
                                    <li>{{ $t('lang.resume.euarc-4') }}</li>
                                </ul>
                            </div>
                            <div class="resume-item">
                                <h4>{{ $t('lang.resume.asir') }}</h4>
                                <h5>2010 - 2012 (2000 {{ $t('lang.resume.hours')}})</h5>
                                <p><em>I.E.S. Mare Nostrum (Alicante)</em></p>
                                <ul>
                                    <li>{{ $t('lang.resume.asir-1') }}</li>
                                    <li>{{ $t('lang.resume.asir-2') }}</li>
                                </ul>
                            </div>
                            <div class="resume-item">
                                <h4>{{ $t('lang.resume.previous') }}</h4>
                                <h5>1992 - 2010</h5>
                                <p><em>{{ $t('lang.resume.platforms')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.resume.previous-desc') }}</li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                            <h3 class="resume-title">{{ $t('lang.experience.experience') }}</h3>
                            <div class="resume-item">
                                <h4>{{ $t('lang.experience.smartway-responsability') }}</h4>
                                <h5>{{ $t('lang.experience.april')}} 2022 - {{ $t('lang.resume.actualidad')}}</h5>
                                <p><em>{{ $t('lang.experience.smartway-company')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.experience.smartway-resp1')}}</li>
                                </ul>
                            </div>

                            <div class="resume-item">
                                <h4>{{ $t('lang.experience.everis-responsibility') }}</h4>
                                <h5>{{ $t('lang.experience.august')}} 2020 - {{ $t('lang.experience.april')}} 2022</h5>
                                <p><em>{{ $t('lang.experience.everis-companyname')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.experience.everis-resp-1')}}</li>
                                </ul>
                            </div>

                            <div class="resume-item">
                                <h4>{{ $t('lang.experience.rs-responsibility') }}</h4>
                                <h5>{{ $t('lang.experience.june')}} 2013 - {{ $t('lang.experience.august')}} 2020</h5>
                                <p><em>{{ $t('lang.experience.rs-companyname')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.experience.rs-resp-1')}}</li>
                                    <li>{{ $t('lang.experience.rs-resp-2')}}</li>
                                    <li>{{ $t('lang.experience.rs-resp-3')}}</li>
                                </ul>
                            </div>

                            <div class="resume-item">
                                <h4>{{ $t('lang.experience.aysti-responsibility') }}</h4>
                                <h5>{{ $t('lang.experience.september')}} 2010 - {{ $t('lang.experience.june')}} 2013</h5>
                                <p><em>{{ $t('lang.experience.aysti-companyname')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.experience.aysti-resp-1')}}</li>
                                    <li>{{ $t('lang.experience.aysti-resp-2')}}</li>
                                    <li>{{ $t('lang.experience.aysti-resp-3')}}</li>
                                    <li>{{ $t('lang.experience.aysti-resp-4')}}</li>
                                </ul>
                            </div>

                            <div class="resume-item">
                                <h4>{{ $t('lang.experience.runtec-responsibility') }}</h4>
                                <h5>{{ $t('lang.experience.january')}} 2005 - {{ $t('lang.experience.march') }} 2010</h5>
                                <p><em>{{ $t('lang.experience.runtec-companyname')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.experience.runtec-resp-1')}}</li>
                                    <li>{{ $t('lang.experience.runtec-resp-2')}}</li>
                                    <li>{{ $t('lang.experience.runtec-resp-3')}}</li>
                                    <li>{{ $t('lang.experience.runtec-resp-4')}}</li>
                                    <li>{{ $t('lang.experience.runtec-resp-5')}}</li>
                                </ul>
                            </div>

                            <div class="resume-item">
                                <h4>{{ $t('lang.experience.jobymar-responsibility') }}</h4>
                                <h5>{{ $t('lang.experience.october')}} 2001 - {{ $t('lang.experience.january') }} 2005</h5>
                                <p><em>{{ $t('lang.experience.jobymar-companyname')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.experience.jobymar-resp-1')}}</li>
                                    <li>{{ $t('lang.experience.jobymar-resp-2')}}</li>
                                    <li>{{ $t('lang.experience.jobymar-resp-3')}}</li>
                                    <li>{{ $t('lang.experience.jobymar-resp-4')}}</li>
                                </ul>
                            </div>

                            <div class="resume-item">
                                <h4>{{ $t('lang.experience.oim-responsibility') }}</h4>
                                <h5>{{ $t('lang.experience.november')}} 1999 - {{ $t('lang.experience.october') }} 2001</h5>
                                <p><em>{{ $t('lang.experience.oim-companyname')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.experience.oim-resp-1')}}</li>
                                    <li>{{ $t('lang.experience.oim-resp-2')}}</li>
                                    <li>{{ $t('lang.experience.oim-resp-3')}}</li>
                                    <li>{{ $t('lang.experience.oim-resp-4')}}</li>
                                </ul>
                            </div>

                            <div class="resume-item">
                                <h4>{{ $t('lang.experience.daniel-responsibility') }}</h4>
                                <h5>{{ $t('lang.experience.september')}} 1998 - {{ $t('lang.experience.june') }} 1999</h5>
                                <p><em>{{ $t('lang.experience.daniel-companyname')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.experience.daniel-resp-1')}}</li>
                                </ul>
                            </div>

                            <div class="resume-item">
                                <h4>{{ $t('lang.experience.pih-responsibility') }}</h4>
                                <h5>{{ $t('lang.experience.december')}} 1993 - {{ $t('lang.experience.september') }} 1998</h5>
                                <p><em>{{ $t('lang.experience.pih-companyname')}}</em></p>
                                <ul>
                                    <li>{{ $t('lang.experience.pih-resp-1')}}</li>
                                    <li>{{ $t('lang.experience.pih-resp-2')}}</li>
                                </ul>
                            </div>

                        </div>
                    </div>

                </div>
            </section><!-- End Resume Section -->

            <!-- ======= Services Section ======= -->
            <section id="services" class="services">
                <div class="container">

                    <div class="section-title">
                        <h2>{{ $t('lang.services.services')}}</h2>
                        <p>{{ $t('lang.services.services-desc')}}</p>
                    </div>

                    <div class="row">
                        <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up">
                            <div class="icon"><i class="icofont-calculations"></i></div>
                            <h4 class="title">{{ $t('lang.services.service-1')}}</h4>
                            <p class="description"></p>
                        </div>
                        <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="100">
                            <div class="icon"><i class="icofont-responsive"></i></div>
                            <h4 class="title">{{ $t('lang.services.service-2')}}</h4>
                            <p class="description"></p>
                        </div>
                        <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="200">
                            <div class="icon"><i class="icofont-database"></i></div>
                            <h4 class="title">{{ $t('lang.services.service-3')}}</h4>
                            <p class="description"></p>
                        </div>
                        <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="300">
                            <div class="icon"><i class="icofont-dashboard-web"></i></div>
                            <h4 class="title">{{ $t('lang.services.service-4')}}</h4>
                            <p class="description"></p>
                        </div>
                        <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="400">
                            <div class="icon"><i class="icofont-iphone"></i></div>
                            <h4 class="title">{{ $t('lang.services.service-5')}}</h4>
                            <p class="description"></p>
                        </div>
                        <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="500">
                            <div class="icon"><i class="icofont-ui-contact-list"></i></div>
                            <h4 class="title">{{ $t('lang.services.service-6')}}</h4>
                            <p class="description"></p>
                        </div>
                    </div>

                </div>
            </section><!-- End Services Section -->

            <!-- ======= Contact Section ======= -->
            <section id="contact" class="contact">
                <div class="container">

                    <div class="section-title">
                        <h2>{{ $t('lang.contact.contact')}}</h2>
                    </div>

                    <div class="row" data-aos="fade-in">

                        <div class="col-lg-5 d-flex align-items-stretch">
                            <div class="info">
                                <div class="address">
                                    <i class="icofont-google-map"></i>
                                    <h4>{{ $t('lang.contact.address')}}:</h4>
                                    <p>Apartado de Correos, 3016 - 03080 Alicante (España)</p>
                                </div>

                                <div class="email">
                                    <i class="icofont-envelope"></i>
                                    <h4>{{ $t('lang.contact.email')}}:</h4>
                                    <p><a href="mailto:info@juanfermin.com">info@juanfermin.com</a></p>
                                </div>


                            </div>

                        </div>

                        <div class="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3129.2351076733644!2d-0.5110419850175183!3d38.3435400796599!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd62366917704051%3A0x6704b8361acac1a1!2sCalle%20Asturias%2C%2003007%20Alicante%20(Alacant)%2C%20Alicante!5e0!3m2!1ses!2ses!4v1589566552670!5m2!1ses!2ses" frameborder="0" style="border:0; width: 100%; height: 290px;" allowfullscreen></iframe>
                        </div>

                    </div>

                </div>
            </section><!-- End Contact Section -->

        </main><!-- End #main -->

        <!-- ======= Footer ======= -->
        <footer id="footer">
            <div class="container">

                <div class="copyright">
                    &copy; <span>Juan Fermín - 2022</span>
                </div>
            </div>
        </footer><!-- End  Footer -->

        <a href="#" class="back-to-top"><i class="icofont-simple-up"></i></a>
    </div>
</template>

<script>


    export default {
        name: 'Content',
    }
</script>